import {useSelector} from 'react-redux';



export default function usePermissions() {
	return useSelector(state => state.permissions);
}
